import { createContext } from 'react';

export const OptionsContext = createContext();
